(function() {
  'use strict';

  class StainTracker {
    constructor() {
      this.init();
    }

    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.bindEvents());
      } else {
        this.bindEvents();
      }
    }

    bindEvents() {
      document.addEventListener('change', (event) => {
        const stainInput = this.getStainInput(event.target);
        if (stainInput) {
          // Use setTimeout to ensure the checkbox state is updated
          setTimeout(() => this.trackSelection(stainInput), 10);
        }
      });
    }

    getStainInput(target) {
      return target.closest('input[data-grid-stain-item], input[data-addon-checkbox]') ||
          target.closest('.stains-swatch, .card-product-stains')?.querySelector('input[type="checkbox"]');
    }

    getProductName(input) {
      const isProductPage = window.location.pathname.includes('/products/');

      if (isProductPage) {
        return document.querySelector('.product-details-wrapper h1')?.textContent?.trim() || 'Unknown Product';
      } else {
        // Closest product card for collection/grid pages
        const productCard = input.closest('.card-product, .product-card, .card');
        return productCard?.querySelector('.card-title a, .product-title a, h2 a')?.textContent?.trim() || 'Unknown Product';
      }
    }

    getStainName(input) {
      return input.closest('.card-product-stains')?.querySelector('.stains-title')?.textContent?.trim() ||
          input.getAttribute('data-stain-feature') ||
          input.closest('label')?.querySelector('img')?.alt ||
          'Unknown Stain';
    }

    trackSelection(input) {
      if (typeof dataLayer === 'undefined') return;

      try {
        // Only track when a stain is actually selected (not deselected)
        if (!input.checked) {
          return;
        }
        const isProductPage = window.location.pathname.includes('/products/');
        const productName = this.getProductName(input);
        const stainName = this.getStainName(input);


        dataLayer.push({
          event: 'stain_selection',
          stain_name: stainName,
          product_name: productName,
          stain_price: parseFloat(input.getAttribute('data-price') || '0'),
          page_type: isProductPage ? 'product' : 'collection',
          selection_state: 'selected'
        });

      } catch (error) {
        // Silent fail for GTM
      }
    }
  }

  // Run once when GTM tag fires
  new StainTracker();

})();
